'use client'

import React, { useState } from 'react'

import styles from './fingers.module.scss'

const EvirmaLogo: React.FC = () => {
  const [clicked, setClicked] = useState(false)
  const handleClick = () => {
    setClicked(true)
    setTimeout(() => setClicked(false), 100)
  }

  return (
    <>
      <div className={styles.fingers}>
        <span className={styles.fingersIcon} onClick={handleClick} style={{ opacity: clicked ? 0.6 : 0.2 }}></span>
      </div>
    </>
  )
}

export default EvirmaLogo
